<div class="modal active rcsSettings">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Reference Coordinate System</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
        <div class="fields__container__tabs">
          <div class="fields__container__tabs__item">
            <a href="#" data-tab="1" (click)="activateSecondaryData()"  [ngClass]="secondaryDataActive ? 'active' : ''">Activate RCS</a>
            <a href="#" data-tab="1" (click)="activatePrimaryData()"  [ngClass]="primaryDataActive ? 'active' : ''">Enable RCS</a>
          </div>
        </div>
        <form autocomplete="off"  [ngClass]="[primaryDataActive ? 'active' : '']" name="ngRCSForm" #ngForm="ngForm" id="rcsForm" class="" style="max-height: 315px;">

          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                    <label>Available Reference Coordinate System List</label>
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">EPSG</th>
                          <th scope="col">Name</th>
                          <th scope="col">Active</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of configurationController.currentConfiguration.rcs"
                          (click)="el.isselected = !el.isselected"
                          [class.highlighted]="el.isselected"
                          [class.deleted]="el.istodelete"
                        >
                          <td>{{ el.epsg }}</td>
                          <td>{{ el.name }}</td>
                          <td>{{ el.enabled }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn">
                      <a (click)="enableRCS()">Enable</a>
                      <a (click)="disableRCS()">Disable</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
        <div [ngStyle]="{'display': secondaryDataActive ? 'block' : 'none' }">
          <div class="row">
            <div class="row__item">
              <div *ngFor="let el of coordenatesController.rcsList">
                  <p>
                    {{ el.epsg }}-{{ el.name }}
                    <span [ngClass]="el.isactive? 'active' : ''" (click)="activateRCS(el)">ACTIVE</span>
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
